import facebookIcon from '../images/social-media-icons/facebook-icon.svg';
import twitterIcon from '../images/social-media-icons/twitter-icon.svg';
import youtubeIcon from '../images/social-media-icons/youtube-icon.svg';
import instagramIcon from '../images/social-media-icons/instagram-icon.svg';

export const socialMediaIcons = [
  { label: 'Facebook', svg: facebookIcon, to: 'https://www.facebook.com/TheSlasherApp' },
  { label: 'Twitter', svg: twitterIcon, to: 'https://twitter.com/theslasherapp' },
  { label: 'YouTube', svg: youtubeIcon, to: 'https://www.youtube.com/channel/UCUcGxsG2u55zlVoe_s8TjcA' },
  { label: 'Instagram', svg: instagramIcon, to: 'https://www.instagram.com/theslasherapp/' },
];
